import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { BaseGoogleAnalyticsCategory } from '../../base-google-analytics-category';

enum SearchFormAction {
  SEARCH = 'search',
  ADD_SEARCH_ROW = 'add_search_row',
  RESET = 'reset',
  SEARCH_SETTINGS_TOGGLE = 'search_settings_toggle'
}

export class SearchForm extends BaseGoogleAnalyticsCategory {
  constructor(ga: GoogleAnalyticsService, isEnabled: boolean) {
    super(ga, 'catalog_search_form', isEnabled);
  }

  public reset() {
    this.event(SearchFormAction.RESET);
  }

  public addSearchRow() {
    this.event(SearchFormAction.ADD_SEARCH_ROW);
  }

  public search(solrQuery: string, numOfResults: number) {
    this.event(SearchFormAction.SEARCH, solrQuery, numOfResults);
  }

  public searchSettingsToggle(key: string) {
    this.event(SearchFormAction.SEARCH_SETTINGS_TOGGLE, key);
  }
}
